"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sweetch = exports.tupleOfUnion = exports.profitableValidators = exports.ledgerFirstValidators = exports.swap = exports.asyncQueue = exports.defaultVoteAccAddrByCurrencyId = exports.clusterByCurrencyId = exports.endpointByCurrencyId = exports.drainSeq = exports.drainSeqAsyncGen = exports.assertUnreachable = exports.LEDGER_VALIDATOR_ADDRESS = void 0;
const web3_js_1 = require("@solana/web3.js");
const fp_1 = require("lodash/fp");
const live_env_1 = require("@ledgerhq/live-env");
exports.LEDGER_VALIDATOR_ADDRESS = "26pV97Ce83ZQ6Kz9XT4td8tdoUFPTng8Fb8gPyc53dJx";
const assertUnreachable = (_) => {
    throw new Error("unreachable assertion failed");
};
exports.assertUnreachable = assertUnreachable;
function drainSeqAsyncGen(...asyncGens) {
    var _a, e_1, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const items = [];
        for (const gen of asyncGens) {
            try {
                for (var _d = true, gen_1 = (e_1 = void 0, __asyncValues(gen)), gen_1_1; gen_1_1 = yield gen_1.next(), _a = gen_1_1.done, !_a; _d = true) {
                    _c = gen_1_1.value;
                    _d = false;
                    const item = _c;
                    items.push(item);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_d && !_a && (_b = gen_1.return)) yield _b.call(gen_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return items;
    });
}
exports.drainSeqAsyncGen = drainSeqAsyncGen;
function drainSeq(jobs) {
    return __awaiter(this, void 0, void 0, function* () {
        const items = [];
        for (const job of jobs) {
            items.push(yield job());
        }
        return items;
    });
}
exports.drainSeq = drainSeq;
function endpointByCurrencyId(currencyId) {
    const endpoints = {
        solana: (0, live_env_1.getEnv)("API_SOLANA_PROXY"),
        solana_devnet: (0, web3_js_1.clusterApiUrl)("devnet"),
        solana_testnet: (0, web3_js_1.clusterApiUrl)("testnet"),
    };
    if (currencyId in endpoints) {
        return endpoints[currencyId];
    }
    throw Error(`unexpected currency id format <${currencyId}>, should be like solana[_(testnet | devnet)]`);
}
exports.endpointByCurrencyId = endpointByCurrencyId;
function clusterByCurrencyId(currencyId) {
    const clusters = {
        solana: "mainnet-beta",
        solana_devnet: "devnet",
        solana_testnet: "testnet",
    };
    if (currencyId in clusters) {
        return clusters[currencyId];
    }
    throw Error(`unexpected currency id format <${currencyId}>, should be like solana[_(testnet | devnet)]`);
}
exports.clusterByCurrencyId = clusterByCurrencyId;
function defaultVoteAccAddrByCurrencyId(currencyId) {
    const voteAccAddrs = {
        solana: exports.LEDGER_VALIDATOR_ADDRESS,
        solana_devnet: undefined,
        solana_testnet: undefined,
    };
    if (currencyId in voteAccAddrs) {
        return voteAccAddrs[currencyId];
    }
    throw new Error(`unexpected currency id format <${currencyId}>, should be like solana[_(testnet | devnet)]`);
}
exports.defaultVoteAccAddrByCurrencyId = defaultVoteAccAddrByCurrencyId;
function asyncQueue(config) {
    const { delayBetweenRuns } = config;
    const q = [];
    const drain = () => __awaiter(this, void 0, void 0, function* () {
        if (q.length > 0) {
            const { lazyPromise, resolve, reject } = q[q.length - 1];
            try {
                resolve(yield lazyPromise());
            }
            catch (e) {
                reject(e);
            }
            finally {
                void setTimeout(() => {
                    q.pop();
                    void drain();
                }, delayBetweenRuns);
            }
        }
    });
    const submit = (lazyPromise) => {
        return new Promise((resolve, reject) => {
            q.unshift({
                lazyPromise,
                resolve,
                reject,
            });
            if (q.length === 1) {
                void drain();
            }
        });
    };
    return {
        submit,
    };
}
exports.asyncQueue = asyncQueue;
function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
exports.swap = swap;
// move Ledger validator to the first position
function ledgerFirstValidators(validators) {
    const [ledgerValidator, restValidators] = (0, fp_1.partition)(v => v.voteAccount === exports.LEDGER_VALIDATOR_ADDRESS, validators);
    return ledgerValidator.concat(restValidators);
}
exports.ledgerFirstValidators = ledgerFirstValidators;
function profitableValidators(validators) {
    return validators.filter(v => v.commission < 100);
}
exports.profitableValidators = profitableValidators;
// https://stackoverflow.com/a/60132060
const tupleOfUnion = () => (array) => array;
exports.tupleOfUnion = tupleOfUnion;
function sweetch(caze, cases) {
    return cases[caze];
}
exports.sweetch = sweetch;
//# sourceMappingURL=utils.js.map